module.exports = __webpack_public_path__ + "c5ed5ed8fca6812a5c17eafe22a85317.png";